export default __webpack_public_path__ + "static/media/tick.6441bd93.svg";